import { render, staticRenderFns } from "./AppNavDrawer.vue?vue&type=template&id=e3a63946&"
import script from "./AppNavDrawer.vue?vue&type=script&lang=ts&"
export * from "./AppNavDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports